var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('Breadcrumb'),(_vm.isAdmin)?_c('SearchEngine'):_vm._e(),_c('Profile',{attrs:{"largeAvatar":_vm.largeAvatar,"documentsImage":_vm.documentsImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }